import {
  CheckboxProps as CheckboxPropsMui,
  Checkbox as CheckboxUi,
  FormControlLabel,
} from '@mui/material';
import { ReactNode } from 'react';
import { useTheme } from '../../hooks/useTheme';
import { styled } from '../../utils/styled';
import { Typography } from '../Typography';

const StyledCheckboxUi = styled(CheckboxUi)`
  &.Mui-checked:hover {
    color: ${({ theme }) => theme.palette.primary.dark};
  }
`;
export interface CheckboxProps
  extends Pick<
    CheckboxPropsMui,
    'checked' | 'name' | 'onChange' | 'icon' | 'checkedIcon'
  > {
  readonly label: string;
  readonly value?: string;
  readonly disabled?: boolean;
  readonly additionalLabel?: ReactNode;
}

export function Checkbox({
  disabled,
  value,
  label,
  additionalLabel,
  checked,
  ...props
}: CheckboxProps) {
  const theme = useTheme();
  return (
    <FormControlLabel
      control={
        <StyledCheckboxUi
          checked={checked}
          slotProps={{
            input: {
              'aria-label': label,
              checked,
            },
          }}
          {...props}
        />
      }
      disabled={disabled}
      label={
        <Typography
          color={
            disabled ? theme.palette.neutral[300] : theme.palette.neutral[600]
          }
          variant="body"
        >
          {label}
          {additionalLabel}
        </Typography>
      }
      value={value}
    />
  );
}
